import * as React from 'react';
import { connect } from 'react-redux';
import { AdminSurveyOverview } from '../../components/pages/survey-admin/AdminSurveyOverview';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/ConfirmScheduleStore';
import { SummaryOverviewPageStateSetter } from '../state-setter/SummaryOverviewPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const AdminSurveyOverviewContainer: React.ComponentType<{ surveyId: number }> = connect(
	(state: IApplicationState) => ({
		...state.confirmSchedule,
	}),
	{ ...ActionCreators },
)(AdminSurveyOverview);

export class AdminSurveyOverviewPage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		const surveyId = parseInt(this.props.match.params.surveyId, 10);
		return (
			<>
				<AdminSurveyOverviewContainer surveyId={surveyId} />
				<SummaryOverviewPageStateSetter {...this.props} />
			</>
		);
	}
}
